import React from "react";
import i18n from "../../../i18n";
import {showMultiLingualText} from "@/utils/LanguageUtils";


export default function TextBlock({ item }) {

    return (
        <div>
            {item && i18n.language &&
                <>
                    { item.data['headtext'] &&
                        <div className="mb-2">
                            <strong>{ showMultiLingualText(item.data['headtext']) }</strong>
                        </div>
                    }

                    { item.data['text'] &&
                        <div style={{whiteSpace: 'break-spaces'}}>
                            { showMultiLingualText(item.data['text']) }
                        </div>
                    }
                </>
            }
        </div>
    )
}